export default
{
    components:
    {

    },

    props:
    {
        content: { type: Object, default: null }
    },

    data()
    {
        return {
            mouse: {
                x: 0,
                y: 0,
                smooth: {
                    x: 0,
                    y: 0
                }
            },

            image: ''
        }
    },

    created()
    {
        this.eventHub.$on('window:tick', this.onTick)
    },

    mounted()
    {
        // get random image
        this.image = this.content.images[this.getRandomInt(0, this.content.images.length)]

        this.$emit('page:ready')
    },

    destroyed()
    {
        this.eventHub.$off('window:tick', this.onTick)
    },

    methods:
    {
        onMouseMove(event)
        {
            this.mouse.x = event.pageX
            this.mouse.y = event.pageY
        },

        onTick()
        {
            this.mouse.smooth.x += (this.mouse.x - this.mouse.smooth.x) * 0.1
            this.mouse.smooth.y += (this.mouse.y - this.mouse.smooth.y) * 0.1
        },

        getRandomInt(min, max)
        {
            return Math.floor(Math.random() * max) + min
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-page-404/script.js